import { useCallback } from 'react';
import { getPlatform } from '../common/firebase';

const DEEP_LINK_TIMEOUT = 2000;

const APP_STORE_URL = 'https://apps.apple.com/us/app/deks-xyz/id6749857801';
const PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=xyz.deks.app';

const UNIVERSAL_LINK_BASE = 'https://deks.xyz';

const useOpenApp = () => {
  const openApp = useCallback((path = '') => {
    const platform = getPlatform();
    let deepLinkUrl;
    let storeUrl;

    const universalLink = `${UNIVERSAL_LINK_BASE}${path}`;

    if (platform === 'ios') {
      deepLinkUrl = universalLink;
      storeUrl = APP_STORE_URL;
    } else if (platform === 'android') {
      deepLinkUrl = universalLink;
      storeUrl = PLAY_STORE_URL;
    } else {
      deepLinkUrl = universalLink;
      storeUrl = APP_STORE_URL;
    }

    let appOpened = false;
    let timeoutId;

    const cleanup = () => {
      clearTimeout(timeoutId);
      window.removeEventListener('blur', handleBlur);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };

    const handleBlur = () => {
      appOpened = true;
      cleanup();
    };

    const handleVisibilityChange = () => {
      if (document.hidden) {
        appOpened = true;
        cleanup();
      }
    };

    window.addEventListener('blur', handleBlur);
    document.addEventListener('visibilitychange', handleVisibilityChange);

    const newWindow = window.open(deepLinkUrl, '_blank');

    if (
      !newWindow ||
      newWindow.closed ||
      typeof newWindow.closed === 'undefined'
    ) {
      try {
        window.location.href = deepLinkUrl;
      } catch (e) {
        console.error('Error opening Universal Link:', e);
      }
    } else {
      const checkWindow = setInterval(() => {
        try {
          if (newWindow.closed) {
            appOpened = true;
            clearInterval(checkWindow);
            cleanup();
          } else if (newWindow.location.href !== 'about:blank') {
            newWindow.close();
            clearInterval(checkWindow);
            cleanup();
            window.open(storeUrl, '_blank');
            return;
          }
        } catch (e) {
          newWindow.close();
          clearInterval(checkWindow);
          cleanup();
          window.open(storeUrl, '_blank');
          return;
        }
      }, 100);
    }

    timeoutId = setTimeout(() => {
      cleanup();

      if (!appOpened) {
        window.open(storeUrl, '_blank');
      }
    }, DEEP_LINK_TIMEOUT);
  }, []);

  return { openApp };
};

export default useOpenApp;
